export function normalizeProfileEmail(email) {
	return typeof email === "string" ? email.trim().toLowerCase() : "";
}
